import {html, render} from 'lit';
import {TerminalPoint, TripStop} from '../api/trips-api';
import {
  timestampsToDaysHoursMinutes,
  utcToLocalDateTime,
} from '../services/date';
import {tripMarkerConfig} from './trips';

export function getFormattedTimes(point: TerminalPoint) {
  const arrivalTimePrecise = utcToLocalDateTime(
    point.arrival?.timestamp_utc,
    true
  );
  const arrivalTime = arrivalTimePrecise?.replace(/:\d{2} /, ' ');

  const departureTimePrecise = utcToLocalDateTime(
    point.departure?.timestamp_utc,
    true
  );
  const departureTime = departureTimePrecise?.replace(/:\d{2} /, ' ');

  const hasArrival = Boolean(arrivalTime);
  const hasDeparture = Boolean(departureTime);

  return {
    arrivalTime,
    arrivalTimePrecise,
    departureTime,
    departureTimePrecise,
    hasArrival,
    hasDeparture,
  };
}

export function createStaticStopMarker(point: TripStop) {
  return `pin-m-${point.label.toLowerCase()}+ffffff(${point.coordinates})`;
}

export function createStaticTerminalMarker(point: TerminalPoint) {
  const {hasArrival, hasDeparture} = getFormattedTimes(point);

  let pin;
  switch (true) {
    case hasArrival && hasDeparture:
      pin = 'pin-l-circle-stroked+0000cc';
      break;
    case hasArrival:
      pin = 'pin-l-s+ff9b71'; // start
      break;
    case hasDeparture:
      pin = 'pin-l-f+42d49c'; // finish
      break;
    default:
      pin = 'pin-l-circle-stroked+0000cc';
  }

  return `${pin}(${point.coordinates.join(',')})`;
}

export function createTerminalMarker(point: TerminalPoint) {
  const arrowStyleConfig = tripMarkerConfig[point.direction];
  const arrowStyles = Object.entries(arrowStyleConfig.style)
    .map(([prop, val]) => `${prop}: ${val};`)
    .join(' ');

  const {
    arrivalTime,
    arrivalTimePrecise,
    departureTime,
    departureTimePrecise,
    hasArrival,
    hasDeparture,
  } = getFormattedTimes(point);

  const duration = getDuration(point);

  // Top-level marker
  const marker = document.createElement('div');

  const template = html`
    <div class="marker" @click=${(e: Event) => e.stopPropagation()}>
      <div style="position: relative;">
        <div class="marker-content row no-wrap items-center shadow-2">
          <div>
            ${hasArrival
              ? html`<div class="row justify-center text-center text-no-wrap">
                  ${arrivalTime}
                </div>`
              : ''}
            ${hasArrival && hasDeparture
              ? html`<div>&nbsp;&ndash;&nbsp;</div>`
              : ''}
            ${hasDeparture
              ? html`<div class="row justify-center text-center text-no-wrap">
                  ${departureTime}
                </div>`
              : ''}
          </div>
          ${arrivalTime || departureTime
            ? html` <zubie-tooltip>
                ${arrivalTime
                  ? html` <strong>Arrived </strong>
                      ${arrivalTimePrecise}
                      <br />`
                  : ''}
                ${departureTime
                  ? html` <strong>Left </strong>
                      ${departureTimePrecise}
                      <br />`
                  : ''}
                ${duration ? html`<em>${duration}</em>` : ''}
              </zubie-tooltip>`
            : ''}
        </div>
        <svg class="arrow" height="18px" width="10px" style="${arrowStyles}">
          <polygon points="0 1, 5 1, 10 1, 5 15"></polygon>
        </svg>
      </div>
    </div>
  `;

  render(template, marker);

  // const button = document.createElement('button'); // not used

  return marker;

  //         <q-btn
  //           v-if="showCamera && focusablePoint"
  //           color="primary"
  //           flat
  //           icon="zoom_in"
  //           size="xs"
  //           square
  //           @click="$emit('point-focused', focusablePoint)"
  //         >
  //           <q-tooltip>View details</q-tooltip>
  //         </q-btn>
}

export function getDuration(point: TerminalPoint) {
  // Duration from arrival & departure difference
  if (point.arrival?.timestamp_utc && point.departure?.timestamp_utc) {
    return timestampsToDaysHoursMinutes(
      point.arrival.timestamp_utc,
      point.departure.timestamp_utc
    );
  }

  // TODO: in-progress trip duration

  // const vehicleKey =
  //   this.$route.name === 'vehicleTrips' && this.$route.params.key;
  // if (vehicleKey) {
  //   const vehicle = this.vehicles[vehicleKey];
  //   const lastTripKey = _get(vehicle, 'lastTrip.key');
  //   if (lastTripKey && lastTripKey === point.arrival.tripKey) {
  //     const now = dayjs();
  //     const arrived = dayjs.utc(point.arrival.timestamp_utc).local();
  //     const durationInSeconds = now.diff(arrived, 'second');
  //     return secondsToDaysHoursMinutes(durationInSeconds);
  //   }
  // }

  return '';
}
